module.exports = __webpack_public_path__ + "static/Bascom-953571f0722336c0ee7515ffe2949946.jpg";